import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import Sortable      from 'react-sortablejs';
import ContentsModal from 'contents_modal';

import ProgressCard     from './progress-card';

// -------------------------------------------------------


class ProgressSpace extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      group_data       : {},
      group_modal      : false,
      influencer_modal : false,
    };
  }
  // -------------------------------------------------------
  
  toggleGroupModal(flg, data) {
    this.setState({ group_modal: flg, group_data: data });
  }
  // -------------------------------------------------------
  
  render() {
    let base = this.props.base;
    
    let data = this.props.data;
    
    let list = data.list;
    if( list == undefined ) list = [];
    
    return (
      <div className={'progress-space '+ data.id}>
        <h2><i className="material-icons">{data.icon}</i>{data.name} ({list.length}<span>人</span>)</h2>
        <Sortable options={{ group: 'shared', animation: 150 }} tag="ul" className="progress-scroll" onChange={this.props.change_ev.bind(this)}>
          { list.map((d, key) => {
            return <ProgressCard key={key} data={d} base={base} />;
          })}
        </Sortable>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ProgressSpace;